<template>
  <div class="container">
    <el-form>
      <el-form-item
        :label="ratioTypeMap[r.type]"
        v-for="(r, i) in ratios"
        :key="i"
      >
        <div class="flex" style="width: 240px">
          <el-input
            v-model="r.service_rate"
            placeholder="比例，如0.1"
            type="number"
            :max="1"
            :min="0"
          ></el-input>
          <el-button v-if="r.id" type="primary" @click="updateRatioInfo(r)"
            >更新</el-button
          >
          <el-button v-else type="success" @click="addRatioInfo(r)"
            >添加</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      ratioTypeMap: {
        t: "教学订场",
        v: "会员卡",
      },
      ratios: [],
      id: "",
      is_init: false,
    };
  },

  mounted() {
    this.ratios = [
      { service_rate: "", type: "t" },
      { service_rate: "", type: "v" },
    ];
    this.id = this.$route.query.id;
  },

  methods: {
    init() {
      if (!this.is_init) {
        this.is_init = true;
        this.getRatio();
      }
    },
    getRatio() {
      let data = {
        venue_id: this.id,
      };
      this.$get("/shared/venuerate/queryListPage", data).then((res) => {
        // this.ratios = res.data.data;
        let all = [...this.ratios, ...res.data.data];
        let map = {};
        all.forEach((item) => {
          map[item.type] = item;
        });
        this.ratios = Object.values(map);
      });
    },
    updateRatioInfo(row) {
      if (row.service_rate < 0 || row.service_rate > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        id: row.id,
        service_rate: row.service_rate,
      };
      this.$post("/shared/venuerate/update", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
    addRatioInfo(row) {
      if (row.service_rate < 0 || row.service_rate > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        venue_id: this.id,
        service_rate: row.service_rate,
        type: row.type,
      };
      this.$post("/shared/venuerate/insert", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>